exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".btn-link i[data-v-aae8d4a4]{color:#0096f5}", ""]);

// exports
